import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumbs from '../navigation/Breadcrumbs';
import { buildServiceBreadcrumbs } from '../navigation/breadcrumbUtils';
import './AIMLServices.css';

const AIMLServices = () => {
  const location = useLocation();
  const servicesIndexView = location.state?.servicesIndexView;
  const backPath = servicesIndexView ? '/services' : '/';

  return (
    <div className="ai-ml-services-page-wrapper">
      <div className="ai-ml-services-page-container">
        <Breadcrumbs
          items={buildServiceBreadcrumbs('services', 'AI & ML Services')}
        />

        <div className="ai-ml-services-back-link">
          <Link
            to={backPath}
            state={servicesIndexView ? { servicesIndexView } : undefined}
          >
            {servicesIndexView ? '\u2190 Back' : '\u2190 Back to Home'}
          </Link>
        </div>

        <div className="ai-ml-services-page-hero">
          <h1>AI & Machine Learning Services</h1>
          <p>
            BlackRoth delivers intelligent AI & Machine Learning solutions
            that enable automation, predictive insights, and data-driven
            decision-making for modern enterprises.
          </p>
        </div>

        <section className="ai-ml-services-page-section">
          <h2>Overview</h2>
          <p>
            Artificial Intelligence and Machine Learning are transforming how
            businesses operate. BlackRoth helps organizations design, develop,
            and deploy AI-driven systems that solve real-world problems and
            scale with business growth.
          </p>
        </section>

        <section className="ai-ml-services-page-section">
          <h2>Core Capabilities</h2>
          <p>
            Our AI & ML solutions focus on accuracy, scalability, and
            responsible AI practices, ensuring long-term value and reliable
            performance across enterprise environments.
          </p>
        </section>

        <section className="ai-ml-services-page-section">
          <h2>Services We Offer</h2>
          <ul className="ai-ml-services-service-list">
            <li>AI Strategy & Consulting</li>
            <li>Custom Machine Learning Model Development</li>
            <li>Predictive & Prescriptive Analytics</li>
            <li>Natural Language Processing (NLP)</li>
            <li>Computer Vision Solutions</li>
            <li>AI-Powered Automation</li>
            <li>Model Deployment & MLOps</li>
            <li>AI Integration with Existing Systems</li>
          </ul>
        </section>

        <section className="ai-ml-services-page-section">
          <h2>Industry Use Cases</h2>
          <p>
            BlackRoth's AI & ML services are used across finance, healthcare,
            retail, manufacturing, logistics, and technology to improve
            efficiency, accuracy, and customer experiences.
          </p>
        </section>

        <section className="ai-ml-services-page-section">
          <h2>Technology Stack</h2>
          <p>
            We work with modern AI technologies including Python, TensorFlow,
            PyTorch, Scikit-learn, cloud-based AI platforms, big data pipelines,
            and scalable deployment frameworks.
          </p>
        </section>

        <section className="ai-ml-services-page-section">
          <h2>Responsible AI & Governance</h2>
          <p>
            BlackRoth follows responsible AI principles, ensuring fairness,
            transparency, data privacy, and compliance throughout the AI
            lifecycle.
          </p>
        </section>
      </div>
    </div>
  );
};

export default AIMLServices;

